<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from "@/helpers/helper";
import { useUserStore } from '@/store/user'


/**
 * Dashboard Component
 */
export default {
  setup(){
        const userStore = useUserStore();
    return {
      userStore
    };
  },
  page: {
    title: "Utilisateurs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Utilisateurs",
      items: [
        {
          text: "Menu",
          href: "/",
        },
        {
          text: "Utilisateurs",
          active: true,
        },
        {
          text: "Un utilisateur",
          active: true,
        },
      ],
      user: {},
      transfers: [],
      accounts: [],
      contacts: [],
      userLocation: null,
      id: "",
      showPermissions: false,
      showLocationModal: false,
      showContact: false,
      showTransaction: false,
      showAccount: false,

    };
  },
  methods: {
    toDate(date) {
      return Helper.toDate(date);
    },

    async getItem() {
      if (!this.userStore.info) {
        await  this.userStore.loadOne(this.id, true).then(data => {
          this.user = data;
          this.accounts = data.accountNumbers;
     })
      } else {
        this.user = this.userStore.info;
        this.accounts =  this.user.accountNumbers ?? [];
      }
    },


    async getNumbers() {
      if (!this.userStore.info?.accountNumbers) {
        await  this.userStore.loadOne(this.id, true).then(data => {
          this.user = data;
          this.accounts = data.accountNumbers;
     })
      } else {
        this.user = this.userStore.info;
        this.accounts =  this.user.accountNumbers ?? [];
      }
    },


  
    async getContacts() {
      console.log('getContacts');
      if (!this.userStore.info?.contacts) {
        await  this.userStore.loadContactsOf(this.id, true).then(data => {
          this.accounts = data;
     })
      } else {
        this.user = this.userStore.info;
        this.accounts =  this.user.contacts ?? [];
      }
    },



  async  getTransactions() {
          console.log('getTransactions');

      if(!this.userStore.info?.transfers){
       await  this.userStore.loadTransfersOf(this.id, true).then(data=>{
          this.transfers = data;
        });
      }else{
        this.transfers = this.userStore.info?.transfers;
      }
  },
  
 

    togglePermissions() {
      this.showPermissions = !this.showPermissions;
    },

    toggleContacts() {
      this.showContact = !this.showContact;
    },

     toggleAccount() {
      this.showAccount = !this.showAccount;
    },

    toggleTransaction() {
      this.showTransaction = !this.showTransaction;
    },

    fetchUserLocation(ip) {
      const apiUrl = `https://ipapi.co/${ip}/json/`;

      if (this.userLocation) {
        this.showLocationModal = true;
        return;
      }

      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          if (!data.error) {
            this.userLocation = data;
             this.showLocationModal = true;
          } else {
            console.error("Erreur lors de la récupération de la localisation :", data.reason);
          }
        })
        .catch(error => console.error("Erreur API :", error));
    },
  },
  computed: {
    userPermissions() {
      return {
        "BG Perm": this.user.bgPerm ?? "Non définie",
        "Call Perm": this.user.callPerm ?? "Non définie",
        "Camera Perm": this.user.cameraPerm === true ? "True" : "False",
        "Finger Perm": this.user.fingerPerm ?? "Non définie",
        "FB Perm": this.user.fbPerm ?? "Non définie",
        "Face Perm": this.user.facePerm ?? "Non définie",
        "Location Perm": this.user.locationPerm ?? "Non définie",
        "Media Perm": this.user.mediaPerm ?? "Non définie",
      };
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getItem();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="user.id">
      
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
          
            <h4 class="card-title d-flex justify-content-between align-items-center">À propos de l'utilisateur 
               <button @click="$router.back()" class="btn btn-secondary btn-sm mb-3 ">
                  Back
              </button>
            </h4>
            
            <div class="row">
              <div class="col-lg-3 mx-auto">
                <img
                  :src="user?.profile"
                  :alt="user.lastName"
                  style="height: 120px; width: 120px"
                  class="border rounded-circle"
                />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>Nom de Famille</dt>
                  <dd>{{ user.lastName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Prénom(s)</dt>
                  <dd>{{ user.firstName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Sexe</dt>
                  <dd>{{ user.gender == true ? "Masculin" : "Féminin" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Email</dt>
                  <dd>{{ user.email }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Code</dt>
                  <dd>{{ user.code }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Pays</dt>
                  <dd>{{ user?.country?.name_fr ?? "Non definie" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Ville</dt>
                  <dd>{{ user.city ?? "Non definie" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Statut</dt>
                  <dd>
                    <button
                      class="badge badge-pill badge-soft-success border-0 py-1 px-3"
                      v-if="user.status == 'active'"
                    >
                      ACTIF
                    </button>
                    <button
                      class="badge badge-pill badge-soft-danger border-0 py-1 px-3"
                      v-else
                    >
                      {{ user.status }}
                    </button>
                  </dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Role</dt>
                  <dd>{{ user.roles?.join(" & ") }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Date d'inscription</dt>
                  <dd>{{ toDate(user.createdAt) }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>IP</dt>
                  <dd>
                    <button class="btn btn-info rounded-pill btn-sm ms-2" @click="fetchUserLocation(user.ip)"> {{ user.ip }}</button>
                    </dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Devise</dt>
                  <dd>{{ user.devise }}</dd>
                </dl>
              </div>
            </div>

            <b-modal v-model="showLocationModal" id="location-modal" centered size="lg" title="Localisation de l'utilisateur">
              <div v-if="userLocation">
                <p><strong>Pays :</strong> {{ userLocation.country_name }}</p>
                <p><strong>Région :</strong> {{ userLocation.region }}</p>
                <p><strong>Ville :</strong> {{ userLocation.city }}</p>
                <p><strong>Code Postal :</strong> {{ userLocation.postal }}</p>
              </div>
              <div v-else>
                <p>Les informations de localisation ne sont pas disponibles.</p>
              </div>
            </b-modal>
            
          </div>
        </div>
      </div>


       <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            
            <h4 class="card-title d-flex justify-content-between align-items-center">Permissions
                <button class="btn btn-primary btn-sm mb-3" @click="togglePermissions">
                {{
                  showPermissions ? "Masquer les permissions" : "Afficher les permissions"
                }}
              </button>
             </h4>
            
             <div v-if="showPermissions" class="row">
                <div class="col-md-3" v-for="(value, key) in userPermissions" :key="key">
                  <dl>
                    <dt>{{ key }}</dt>
                    <dd>{{ value }}</dd>
                  </dl>
                </div>
              </div>

          </div>
        </div>
      </div>



        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">


              <h4 class="card-title d-flex justify-content-between align-items-center">Listes des comptes
                  <button class="btn btn-primary btn-sm mb-3" @click="toggleAccount()">
                    {{
                      showAccount  ? "Masquer" : "Afficher"
                    }}
                  </button>  
                   <button
                    class="btn btn-primary btn-sm mb-3 ms-2"
                    @click="getNumbers()"
                    v-if="showAccount"
                  >
                    {{ accounts.length ? "Rafraichir" : "Charger" }}
                  </button> 
                
                </h4>
              <p class="card-title-desc" v-if="showAccount">
                Le tableau ci-dessous présente la listes des
                <code>comptes</code>.
              </p>

              <div class="table-responsive" v-if="showAccount">
                <table class="table align-middle mb-0">
                  <thead class="bg-light rounded">
                    <tr>
                      <th>#</th>
                      <th>Type</th>
                      <th>Number</th>
                      <th>Mode</th>
                      <th>Status</th>
                      <th>Visibility</th>
                      <th>Method</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(account, i) in accounts" :key="account.id">
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ account.type }}</td>
                      <td>{{ account.number }}</td>
                      <td>{{ account.mode }}</td>
                      <td>{{ account.status }}</td>
                      <td>{{ account.visibility }}</td>
                      <td>{{ account.method?.name ?? account.idOfMethod }}</td>
                      <td>{{ toDate(account.createdAt) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
            </div>
          </div>
        </div>


        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <h4 class="card-title d-flex justify-content-between align-items-center">
                Listes des transactions

                <span>
                  <button class="btn btn-primary btn-sm mb-3" @click="toggleTransaction">
                    {{
                      showTransaction ? "Masquer" : "Afficher"
                    }}
                  </button>
                  <button
                    class="btn btn-primary btn-sm mb-3 ms-2"
                    @click="getTransactions()"
                    v-if="showTransaction"
                  >
                    {{ transfers.length ? "Rafraichir" : "Charger" }}
                  </button>
                </span>
              </h4>
              <p class="card-title-desc" v-if="showTransaction">
                Le tableau ci-dessous présente la listes des
                <code>transactions</code>.
              </p>

              <div class="table-responsive" v-if="showTransaction">
                <table class="table align-middle mb-0">
                  <thead class="bg-light rounded">
                    <tr>
                      <th>#</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Amount</th>
                      <th>Rate</th>
                      <th>Receive</th>
                      <th>Date</th>
                      <th>Statut</th>
                      <th>Voir Detail</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr v-for="(transfer, i) in transfers" :key="transfer.id">
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ transfer.fromAccount }}</td>
                      <td>{{ transfer.toAccount }}</td>
                      <td>{{ transfer.sentAmount }}</td>
                      <td>{{ transfer.rate }}</td>
                      <td>{{ transfer.receivedAmount }}</td>
                      <td>{{ toDate(transfer.createdAt) }}</td>
                      <td>
                        <span
                          v-if="transfer.status == 'error'"
                          class="badge badge-pill badge-soft-danger font-size-11"
                        >
                          {{ transfer.status }}
                        </span>
                        <span
                          v-if="transfer.status !== 'error'"
                          class="badge badge-pill badge-soft-success font-size-11"
                        >
                          {{ transfer.status }}
                        </span>
                      </td>
                      <td>
                        <router-link
                          class="rounded-pill btn-sm btn-primary px-3"
                          :to="'/transfers/' + transfer.id"
                          >Voir detail</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>



        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

                <h4 class="card-title  d-flex justify-content-between align-items-center ">
                  Listes des contacts

                  <span>
                    <button class="btn btn-primary btn-sm mb-3" @click="toggleContacts">
                      {{
                        showContact ? "Masquer" : "Afficher"
                      }}
                    </button>
                    <button
                      class="btn btn-primary btn-sm mb-3 ms-2"
                      @click="getContacts()"
                      v-if="showContact"
                    >
                      {{ transfers.length ? "Rafraichir" : "Charger" }}
                    </button>
                  </span>
                </h4>
                <p class="card-title-desc"  v-if="showContact">
                  Le tableau ci-dessous présente la listes des
                  <code>transactions</code>.
                </p>

                <div  class="table-responsive" v-if="showContact">
                  <table class="table align-middle mb-0">
                    <thead class="bg-light rounded">
                      <tr>
                        <th>#</th>
                        <th>
                          Name</th>
                        <th>Surname</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(contact, i) in contacts" :key="contact.id">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>
                          <img
                            :src="contact.friend?.firstName"
                            :alt="contact.friend?.firstName"
                            style="height: 35px; width: 35px"
                            class="border rounded-circle"
                          />
                          {{ contact.friend?.firstName }}</td>
                        <td>{{ contact.friend?.lastName }}</td>
                        <td>{{ toDate(contact.createdAt) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              
            </div>
          </div>
        </div>


        
    </div>
  </Layout>
</template>
